import { pathToRegexp } from 'path-to-regexp';
import { E2E_TEST_MODE_COOKIE_VALUE } from '@terra/shared-utils';

export const TERRA_PROXY_AUTH_PUBLIC_ROUTES = [
  '/sign-in',
  '/auth-callback',
  '/mcp-oauth-callback',
  '/:locale/auth/mcp/oauth-callback',
] as const;

const TERRA_PROXY_AUTH_PUBLIC_ROUTE_MATCHERS =
  TERRA_PROXY_AUTH_PUBLIC_ROUTES.map(
    (route) => pathToRegexp(route, { end: false }).regexp,
  );

export function isTerraProxyAuthPublicPathname(pathname: string): boolean {
  return TERRA_PROXY_AUTH_PUBLIC_ROUTE_MATCHERS.some((matcher) =>
    matcher.test(pathname),
  );
}

export function isTerraProxyE2eHarnessPathname(pathname: string): boolean {
  return pathname === '/e2e' || pathname.startsWith('/e2e/');
}

export function isTerraProxyE2eHarnessPublicPathname(
  pathname: string,
): boolean {
  return (
    process.env.NODE_ENV !== 'production' &&
    isTerraProxyE2eHarnessPathname(pathname)
  );
}

export function isTerraProxyE2eHarnessPublicForCookie({
  pathname,
  cookieValue,
}: {
  pathname: string;
  cookieValue: string | undefined;
}): boolean {
  return (
    isTerraProxyE2eHarnessPublicPathname(pathname) &&
    cookieValue === E2E_TEST_MODE_COOKIE_VALUE
  );
}
